<div class="row">
  <div class="col-lg-1 col-md-1 col-sm-1"></div>
  <div class="col-lg-10 col-md-10 col-sm-10 ">
    <div *ngIf="stage=='readme'">
      <app-readme></app-readme>

      <div class="pnl-footer readme col-12">
        <button mat-flat-button color="primary" (click)="startForm()" class="btn btn-default btn-proceed" title="Proceed"
          aria-label="Proceed" type="button">
          PROCEED
        </button>
      </div>
    </div>
    <div [hidden]="stage!='form'">
      <h1>{{title}}</h1>
      <mat-horizontal-stepper [linear]="true" #stepper (selectionChange)="stepChanged($event)">
        <ng-template matStepperIcon="done">
          <mat-icon>check</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="edit">
          <mat-icon>check</mat-icon>
        </ng-template>
        <mat-step label="Organiser">
          <app-organiser-form [(value)]="vm.organiserVm"></app-organiser-form>
        </mat-step>
        <mat-step label="Details">
          <app-detail-form [(value)]="vm.detailVm"></app-detail-form>
          <app-description-form [(value)]="vm.descriptionVm"></app-description-form>
          <app-channels-form [(value)]="vm.channelsVm"></app-channels-form>
        </mat-step>
        <mat-step label="Location">
          <app-venue-form [(value)]="vm.venueVm"></app-venue-form>
        </mat-step>
        <mat-step label="Booking">
          <app-booking-form [(value)]="vm.bookingVm"></app-booking-form>
          <app-pricing-form [(value)]="vm.pricingVm"></app-pricing-form>
        </mat-step>
        <mat-step label="Images & Video">
          <app-media-form [(value)]="vm.imagesVm"></app-media-form>
          <app-video-form [(value)]="vm.videoVm"></app-video-form>
        </mat-step>
      </mat-horizontal-stepper>
      <div class="pnl-footer col-12" *ngIf="stage=='form'">
        <!-- <input type="button" (click)="goBack(stepper)" *ngIf="!isFirstStep" class="btn btn-default btn-previous" value="Previous"> -->

        <button mat-button *ngIf="stepper.selectedIndex!=0" (click)="goBack(stepper)"
          class="btn btn-default btn-previous" title="Previous Step" aria-label="Previous Step" type="button">
          Previous
        </button>

        <button mat-button (click)="goForward(stepper)" class="btn btn-default btn-next" title="Next Step"
          aria-label="Next Step" type="button">
          Next
        </button>

        <!-- <input type="button" (click)="goForward(stepper)" class="btn btn-default btn-next" value="Next"> -->
      </div>
    </div>
    <div *ngIf="stage=='review'">

      <app-review [vm]="this.vm" (editInfoEvent)="goToStep($event)"></app-review>

      <!-- <button mat-button (click)="backToForm()" class="btn btn-default back-to-edit" type="button">
        Edit your event information
      </button> -->

      <button mat-button (click)="goToSubmit()" class="btn btn-default btn-next" title="Next Step"
          aria-label="Next Step" type="button">
          Next
        </button>

    </div>
    <div *ngIf="stage=='confirm'">
      <h1>Submit</h1>
      <app-terms-form></app-terms-form>
      <!-- <app-confirmation-form></app-confirmation-form> -->
      <div class="pnl-footer confirmation col-12">
        <form name="confirmationForm" [formGroup]="confirmationForm">
          <div style="float:right;">
            <!-- <input type="button" [disabled]="confirmationForm.invalid" (click)="submit()" class="btn btn-default btn-submit"
                value="Submit Event"> -->
            <!-- confirmationForm.invalid || -->
            <button mat-button [disabled]="confirmationForm.invalid || !options.active" (click)="submit()"
              class="btn btn-default btn-submit" title="Submit this Event" aria-label="Submit this event" type="button">
              Submit Event
            </button>

          </div>

          <div style="float:right; margin-right: 10px; margin-top:15px" [hidden]="options.active">
            <mat-spinner matSuffix diameter="35" style="color:#97116D"></mat-spinner>
          </div>

          <!-- In case we need to address responsiveness on non-desktop devices - apply styles to css and play with device sizes.. -->
          <!-- <div style="transform:scale(0.7);transform-origin:0;"> -->
          <div style="float:right; margin-bottom: 30px; margin-right:30px;">
            <re-captcha formControlName="recaptchaForm"></re-captcha>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="stage=='complete'">
      <h1>Thank you!</h1>
      <p>Thats it, you're all done! We will now review and process your event. We may be in contact with if we need
        anything clarified. </p>
    </div>
    <div *ngIf="stage=='generalFailure'">
      <h1>Something went wrong!</h1>
      <p>Unfortunately something went wrong processing your event. We are really sorry about this, please try again
        later. </p>
    </div>

    <div *ngIf="stage=='validationFailure'">
      <h1>Missing or invalid event details!</h1>
      <p>There are some issues with the event you are trying to submit, please review and amend all highlighted fields.
      </p>
      <!-- <a (click)="backToForm()" class="btn btn-default">Review your event information</a> -->

      <br/><br/>
      <button mat-button (click)="backToForm()" class="btn btn-default btn-review" type="button">
        <mat-icon>arrow_back</mat-icon>
        Review your event information
      </button>
    </div>

    <div *ngIf="stage=='submitFailure'">
      <h1>Error processing event!</h1>
      <p>There appears to be an issue processing the event details submitted, please contact the administrator and
        include the name of the event.</p>
      <!-- <a (click)="backToForm()" class="btn btn-default">Review your event information</a> -->

      <br/><br/>
      <button mat-button (click)="backToForm()" class="btn btn-default btn-review" type="button">
        <mat-icon>arrow_back</mat-icon>
        Review your event information.
      </button>
    </div>
  </div>
  <div *ngIf="showJson">
    <form name="devForm" [formGroup]="devForm">
      <h2>VM Json</h2>
      {{this.vm | json}}
      <p>Enter Json here to set form</p>
      <textarea rows="20" style="width:70%" formControlName="vmJson"></textarea>
      <div>
        <button mat-button (click)="setVm()" class="btn btn-default" type="button">
          Set VM
        </button>
      </div>
      <h2>Schema Json</h2>
      {{this.schema | json}}
    </form>
  </div>

  <div class="col-lg-1 col-md-1 col-sm-1"></div>
</div>